var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAutoOperated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4013 5.56675L2.68464 6.85008C2.45964 7.52508 2.33464 8.25008 2.33464 9.00008C2.33464 12.6751 5.3263 15.6667 9.0013 15.6667C12.6763 15.6667 15.668 12.6751 15.668 9.00008C15.668 5.32508 12.6763 2.33341 9.0013 2.33341C8.2513 2.33341 7.5263 2.45841 6.8513 2.68341L5.5763 1.40841C6.6263 0.933415 7.78464 0.666748 9.0013 0.666748C13.6013 0.666748 17.3346 4.40008 17.3346 9.00008C17.3346 13.6001 13.6013 17.3334 9.0013 17.3334C4.4013 17.3334 0.667969 13.6001 0.667969 9.00008C0.667969 7.77508 0.934636 6.61675 1.4013 5.56675ZM4.83464 3.58341C4.83464 4.27508 4.2763 4.83342 3.58464 4.83342C2.89297 4.83342 2.33464 4.27508 2.33464 3.58341C2.33464 2.89175 2.89297 2.33341 3.58464 2.33341C4.2763 2.33341 4.83464 2.89175 4.83464 3.58341ZM9.0263 6.49175H8.96797L8.0013 9.25008H9.99297L9.0263 6.49175ZM9.0013 14.0001C11.7596 14.0001 14.0013 11.7584 14.0013 9.00008C14.0013 6.24175 11.7596 4.00008 9.0013 4.00008C6.24297 4.00008 4.0013 6.24175 4.0013 9.00008C4.0013 11.7584 6.24297 14.0001 9.0013 14.0001ZM8.40964 5.25008H9.6013L12.1096 11.9167H10.9513L10.3513 10.2167H7.65964L7.0513 11.9167H5.9013L8.40964 5.25008Z",
    fill: "#009EF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAutoOperated);
export default __webpack_public_path__ + "static/media/ic-auto-operated.a8e1bf91e85c6bf83438465b8b28f9e9.svg";
export { ForwardRef as ReactComponent };